export enum TipoEnviosEnum { NOT_STICKY_DATETIME, STICKY_ALWAYS_ANYTIME, STICKY_WEEK_DAY, STICKY_WEEK_DAYTIME,
    STICKY_DAY_DAYTIME, STICKY_SINGLE_DAY, QMP, STICKY_ENGAGE }

const idsTipoEnvios = new Map<TipoEnviosEnum, string>();
idsTipoEnvios.set(TipoEnviosEnum.NOT_STICKY_DATETIME, "NOT_STICKY_DATETIME");
idsTipoEnvios.set(TipoEnviosEnum.STICKY_ALWAYS_ANYTIME, "STICKY_ALWAYS_ANYTIME");
idsTipoEnvios.set(TipoEnviosEnum.STICKY_WEEK_DAY, "STICKY_WEEK_DAY");
idsTipoEnvios.set(TipoEnviosEnum.STICKY_WEEK_DAYTIME, "STICKY_WEEK_DAYTIME");
idsTipoEnvios.set(TipoEnviosEnum.STICKY_DAY_DAYTIME, "STICKY_DAY_DAYTIME");
idsTipoEnvios.set(TipoEnviosEnum.STICKY_SINGLE_DAY, "STICKY_SINGLE_DAY");
idsTipoEnvios.set(TipoEnviosEnum.QMP, "QMP");
idsTipoEnvios.set(TipoEnviosEnum.STICKY_ENGAGE, "STICKY_ENGAGE");

const nombresTipoEnvios = new Map<TipoEnviosEnum, string>();
nombresTipoEnvios.set(TipoEnviosEnum.NOT_STICKY_DATETIME, "Únicamente en ese día y horario");
nombresTipoEnvios.set(TipoEnviosEnum.STICKY_ALWAYS_ANYTIME, "Al ingresar un nuevo usuario");
nombresTipoEnvios.set(TipoEnviosEnum.STICKY_WEEK_DAY, "Todas las semanas, el mismo día");
nombresTipoEnvios.set(TipoEnviosEnum.STICKY_WEEK_DAYTIME, "Todas las semanas, misma hora y día");
nombresTipoEnvios.set(TipoEnviosEnum.STICKY_DAY_DAYTIME, "Todos los días a la misma hora");
nombresTipoEnvios.set(TipoEnviosEnum.STICKY_SINGLE_DAY, "Todo el día");
nombresTipoEnvios.set(TipoEnviosEnum.QMP, "Quiero más preguntas");
nombresTipoEnvios.set(TipoEnviosEnum.STICKY_ENGAGE, "Mantenimiento Engage");

export const obtenerIdTipoEnvios: (tipo: TipoEnviosEnum) => string = tipo => idsTipoEnvios.get(tipo) || "";
export const obtenerNombreTipoEnvios: (tipo: TipoEnviosEnum) => string = tipo => nombresTipoEnvios.get(tipo) || "";

export const obtenerNombresTipoEnvios: () => Array<[TipoEnviosEnum, string]> =
    () => Array.from(nombresTipoEnvios.entries());
